import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Header from "../../utils/components/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import SeperatorHeading from "../../utils/components/SeperatorHeading/SeperatorHeading";
import InspectionType from "../../utils/components/InspectionType/InspectionType";
import FormField from "../../utils/components/FormField/FormField";
import MultiEmailField from "../../utils/components/MultiEmail/MultiEmailField";
import TextFieldBig from "../../utils/components/TextFieldBig/TextFieldBig";
import Events from "../../utils/components/Events/Events";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faEllipsis,
  faPlus,
  faUpload,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { v4 as uuidv4 } from "uuid";
import { PostRequestWithTextResponse } from "../../utils/repository/RequestMaker";
import Endpoints from "../../utils/repository/Endpoints";
import { saveAs } from "file-saver";
import CompanyIncident from "../../utils/components/CompanyIncident/CompanyIncident";
import { addDraft } from "./draftSlice";

const Form = () => {
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const [onTop, setOnTop] = useState(true);
  const [eventList, setEventList] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [submissionType, setSubmissionType] = useState("");
  const [pdf, setPdf] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [pdfURL, setPdfURL] = useState("");
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [sendingData, setSendingData] = useState(false);
  const [projectUUID, setProjectUUID] = useState(uuidv4());
  const inspectionType = useSelector((state) => state.form.inspectionType);
  const user = useSelector((state) => state.login.user);
  const [inspectionTypes, setInspectionTypes] = useState([]);
  const [inspectionTypeError, setInspectionTypeError] = useState(false);
  const [projectError, setProjectError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [leitungInspektionError, setLeitungInspektionError] = useState(false);
  const [teilnehmerInspektionError, setTeilnehmerInspektionError] =
    useState(false);
  const [begehungsdatumError, setBegehungsdatumError] = useState(false);

  const downloadButtonRef = useRef(null);

  const dispatch = useDispatch();
  const draftCount = useSelector((state) => state.drafts.draftCount);

  // ===============

  const { draftId } = useParams(); // Getting the ID from the URL
  const [draft, setDraft] = useState(null);

  // State hooks for form fields
  const [projectName, setProjectName] = useState("");
  const [inspectionsType, setInspectionsType] = useState("");
  const [customer, setCustomer] = useState("");
  const [area, setArea] = useState("");
  const [inspectedDate, setInspectedDate] = useState("");
  const [headOfInspection, setHeadOfInspection] = useState("");
  const [participants, setParticipants] = useState("");
  const [email, setEmail] = useState([]);
  const [otherInfo, setOtherInfo] = useState("");

  //================

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function openModal() {
    setModalIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    setModalIsOpen(false);
  }

  function scrollFunction() {
    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
      setOnTop(false);
    } else {
      setOnTop(true);
    }
  }
  //NIKAL DO
  const onSaveDraft = () => {
    setSendingData(true);
    setFormSubmitted(false);
    setSubmissionType("draft");
    const projekt = JSON.parse(localStorage.getItem("projekt"));
    const inspektionsart = JSON.parse(localStorage.getItem("inspektionsart"));
    const auftraggeber = JSON.parse(localStorage.getItem("auftraggeber"));
    const bereich = JSON.parse(localStorage.getItem("bereich"));
    const begehungsdatum = JSON.parse(localStorage.getItem("begehungsdatum"));
    const leitunginspektion = JSON.parse(
      localStorage.getItem("leitunginspektion")
    );
    const teilnehmerinspektion = JSON.parse(
      localStorage.getItem("teilnehmerinspektion")
    );
    const sonstige = JSON.parse(localStorage.getItem("sonstige"));
    const anmerkung = JSON.parse(localStorage.getItem("anmerkung"));
    const email = JSON.parse(localStorage.getItem("email"));

    let inspected_dates;

    if (begehungsdatum) {
      inspected_dates = properDate(begehungsdatum.split("-").join("."));
    } else {
      inspected_dates = "";
    }

    let incidents =
      inspectionType === "Bausstellenbegehung"
        ? getEventsIncidents()
        : getCompanyIncidents();

    const formData = {
      inspection_type_id: inspektionsart,
      project_name: projekt,
      head_of_inspection: leitunginspektion,
      participants: teilnehmerinspektion,
      note_on_inspection: anmerkung,
      status: "draft",
      other_info: sonstige,
      inspected_date: inspected_dates,
      customer: auftraggeber,
      email: email,
      area: bereich,
      incidents: incidents || [],
    };
    console.log(formData);
    localStorage.setItem(`draft_${Date.now()}`, JSON.stringify(formData));
    dispatch(
      addDraft({
        title: `Draft: ${projekt} - ${properDate(new Date().toISOString())}`,
        content: JSON.stringify(formData, null, 2),
      })
    );

    requestMaker(formData);
  };

  const onSubmit = () => {
    setSendingData(true);
    setFormSubmitted(false);
    setSubmissionType("sent");
    const projekt = JSON.parse(localStorage.getItem("projekt"));
    const inspektionsart = JSON.parse(localStorage.getItem("inspektionsart"));
    const auftraggeber = JSON.parse(localStorage.getItem("auftraggeber"));
    const bereich = JSON.parse(localStorage.getItem("bereich"));
    const begehungsdatum = JSON.parse(localStorage.getItem("begehungsdatum"));
    const leitunginspektion = JSON.parse(
      localStorage.getItem("leitunginspektion")
    );
    const teilnehmerinspektion = JSON.parse(
      localStorage.getItem("teilnehmerinspektion")
    );
    const sonstige = JSON.parse(localStorage.getItem("sonstige"));
    const anmerkung = JSON.parse(localStorage.getItem("anmerkung"));
    const email = JSON.parse(localStorage.getItem("email"));

    if (!inspectionType) {
      setInspectionTypeError(true);
      setSendingData(false);
      return;
    }

    let incidents =
      inspectionType === "Bausstellenbegehung"
        ? getEventsIncidents()
        : getCompanyIncidents();

    const formData = {
      inspection_type_id: inspektionsart,
      project_name: projekt,
      head_of_inspection: leitunginspektion,
      participants: teilnehmerinspektion,
      note_on_inspection: anmerkung,
      status: "sent",
      other_info: sonstige,
      inspected_date: properDate(begehungsdatum.split("-").join(".")),
      customer: auftraggeber,
      email: email,
      area: bereich,
      incidents,
    };
    console.log(formData);
    requestMaker(formData);
  };

  const requestMaker = (formData) => {
    PostRequestWithTextResponse(formData, Endpoints.generateReport)
      .then((result) => {
        setTimeout(() => {
          setFormSubmitted(true);
          setPdf(result);
          setSendingData(false);
        }, 1000);
      })
      .catch((error) => {
        console.error("Error generating the report:", error);
        setSendingData(false);
      });
  };

  const savePdf = async () => {
    var blob = b64toBlob(pdf, "application/pdf");

    const fileHandle = await window.showSaveFilePicker({
      suggestedName:
        JSON.parse(localStorage.getItem("projekt")) + "_" + projectUUID,
      types: [
        {
          description: "PDF Files",
          accept: {
            "application/pdf": [".pdf"],
          },
        },
      ],
    });

    const writableStream = await fileHandle.createWritable();
    await writableStream.write(blob);
    await writableStream.close();

    //setPdfURL(URL.createObjectURL(blob)); saveAs( blob, JSON.parse(localStorage.getItem("projekt")) + "_" + projectUUID );
    //const url = URL.createObjectURL(blob); setPdfURL(url); window.open(url, "_blank");
  };

  const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  useEffect(() => {
    setInspectionTypes(JSON.parse(localStorage.getItem("inspectionType")));
    window.onscroll = function () {
      scrollFunction();
    };
  }, []);

  const getDraftById = (id) => {
    const drafts = JSON.parse(localStorage.getItem("drafts_list"));
    if (drafts) {
      const draft = drafts.find((d) => d.id === id);
      return draft;
    }
    return null; // Return null if no drafts are found or the draft does not exist
  };

  const onMangelClick = () => {
    resetData();
    const projekt = JSON.parse(localStorage.getItem("projekt") || '""').trim();
    const begehungsdatum = JSON.parse(
      localStorage.getItem("begehungsdatum") || '""'
    ).trim();
    const leitungInspektion = JSON.parse(
      localStorage.getItem("leitunginspektion") || '""'
    ).trim();
    const teilnehmerInspektion = JSON.parse(
      localStorage.getItem("teilnehmerinspektion") || '""'
    ).trim();
    const email = JSON.parse(localStorage.getItem("email") || "[]");

    let hasError = false;
    setInspectionTypeError(false);
    setProjectError(false);
    setBegehungsdatumError(false);
    setLeitungInspektionError(false);
    setTeilnehmerInspektionError(false);
    setEmailError(false);

    if (!inspectionType) {
      setInspectionTypeError(true);
      hasError = true;
    }

    if (!projekt) {
      setProjectError(true);
      hasError = true;
    }

    if (!begehungsdatum) {
      setBegehungsdatumError(true);
      hasError = true;
    }

    if (!leitungInspektion) {
      setLeitungInspektionError(true);
      hasError = true;
    }

    if (!teilnehmerInspektion) {
      setTeilnehmerInspektionError(true);
      hasError = true;
    }

    if (email.length === 0) {
      setEmailError(true);
      hasError = true;
    }

    if (hasError) {
      const errorSection =
        document.getElementById("error-section") || document.body;
      errorSection.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    if (inspectionType === "Bausstellenbegehung") {
      setEventList((eventList) => [
        ...eventList,
        <Events index={eventList.length} />,
      ]);
    } else if (
      inspectionType === "Betriebsbegehung" ||
      inspectionType === "Brandschutzbegehung"
    ) {
      setEventList((eventList) => [
        <CompanyIncident index={eventList.length} />,
      ]);
    } else {
      setInspectionTypeError(true);
    }
  };

  const getEventsIncidents = () => {
    let incidents = [];
    for (let i = 0; i < eventList.length; i++) {
      if (localStorage.getItem("gefahrdung" + i) !== null) {
        const unternehmenstyp = JSON.parse(localStorage.getItem("company" + i));
        const gefahrdung = JSON.parse(localStorage.getItem("gefahrdung" + i));
        const gefahrdung_unterkategorie = JSON.parse(
          localStorage.getItem("gefahrdung_unterkategorie" + i)
        );
        const gefahrdung_unterkategorie_type = JSON.parse(
          localStorage.getItem("gefahrdung_unterkategorie_type" + i)
        );
        const allSolutions = JSON.parse(
          localStorage.getItem("risk_solutions") || "[]"
        );
        const risiko_losungen = allSolutions.filter(
          (sol) =>
            sol.risk_sub_category_type_id === gefahrdung_unterkategorie_type
        );

        const selectedSolution =
          risiko_losungen.length > 0 ? risiko_losungen[0].id : null;
        if (
          !gefahrdung ||
          !gefahrdung_unterkategorie ||
          !gefahrdung_unterkategorie_type ||
          selectedSolution.length === 0
        ) {
          alert("Bitte erwähnen Sie die Gefahrdung");
          setSendingData(false);
          return;
        }
        const festgestellter_mangel = JSON.parse(
          localStorage.getItem("festgestellter_mangel" + i)
        );
        const gewerksübergreifend = JSON.parse(
          localStorage.getItem("gewerksübergreifend" + i)
        );
        const ort = JSON.parse(localStorage.getItem("ort" + i));
        const verursachtdurch = JSON.parse(
          localStorage.getItem("verursachtdurch" + i)
        );
        const gewerk = JSON.parse(localStorage.getItem("gewerk" + i));
        const vorgeschlageneschutzmassnahme = JSON.parse(
          localStorage.getItem("vorgeschlageneschutzmassnahme" + i)
        );
        const einstufung = JSON.parse(localStorage.getItem("einstufung" + i));
        var photos = JSON.parse(localStorage.getItem("photos" + i));
        if (!photos) {
          photos = [];
        }
        incidents.push({
          company_type_id: unternehmenstyp,
          risk_category_id: gefahrdung,
          risk_sub_category_id: gefahrdung_unterkategorie,
          risk_sub_category_type_id: gefahrdung_unterkategorie_type,
          risk_solution_id: selectedSolution,
          detected_defect: festgestellter_mangel,
          shared_trade: gewerksübergreifend,
          location: ort,
          caused_by: verursachtdurch,
          worked: gewerk,
          risk_solution: "",
          proposed_protective_measure: vorgeschlageneschutzmassnahme,
          status: einstufung,
          info_photos: photos,
        });
      }
    }
    return incidents;
  };

  const getCompanyIncidents = () => {
    let incidents = [];
    let questions = JSON.parse(
      localStorage.getItem("incident_questions")
    ).filter(
      (_q) =>
        _q.inspection_type_id ===
        JSON.parse(localStorage.getItem("inspektionsart"))
    );

    let numberOfQuestions = questions.length;
    for (let j = 0; j < numberOfQuestions; j++) {
      incidents.push({
        question_id: questions[j].id,
        answer: localStorage.getItem("yn_" + j),
        comment:
          localStorage.getItem("yn_comment_" + j) === "null"
            ? ""
            : localStorage.getItem("yn_comment_" + j) || "",
        status: JSON.parse(localStorage.getItem("status_" + j)) || "",
        info_photos: JSON.parse(localStorage.getItem("photos" + j)) || [],
      });
    }
    return incidents;
  };

  const resetData = () => {
    const preStore = {
      anmerkung: localStorage.getItem("anmerkung"),
      auftraggeber: localStorage.getItem("auftraggeber"),
      leitunginspektion: localStorage.getItem("leitunginspektion"),
      begehungsdatum: localStorage.getItem("begehungsdatum"),
      bereich: localStorage.getItem("bereich"),
      email: localStorage.getItem("email"),
      incident_questions: localStorage.getItem("incident_questions"),
      inspectionType: localStorage.getItem("inspectionType"),
      inspektionsart: localStorage.getItem("inspektionsart"),
      "persist:root": localStorage.getItem("persist:root"),
      projekt: localStorage.getItem("projekt"),
      risk_categories: localStorage.getItem("risk_categories"),
      risk_sub_categories: localStorage.getItem("risk_sub_categories"),
      risk_sub_categories_type: localStorage.getItem(
        "risk_sub_categories_type"
      ),
      risk_solutions: localStorage.getItem("risk_solutions"),
      company_type: localStorage.getItem("company_type"),
      sonstige: localStorage.getItem("sonstige"),
      teilnehmerinspektion: localStorage.getItem("teilnehmerinspektion"),
      token: localStorage.getItem("token"),
      drafts_list: localStorage.getItem("drafts_list"),
    };
    localStorage.clear();
    Object.keys(preStore).forEach((objectName) => {
      localStorage.setItem(objectName, preStore[objectName]);
    });
  };

  useEffect(() => {
    setEventList([]);
    setFormSubmitted(false);
  }, [inspectionType]);

  const properDate = (dateString) => {
    var date = dateString.split(".");
    return date[2] + "." + date[1] + "." + date[0];
  };

  const handleInspectionTypeChange = () => {
    setInspectionTypeError(false);
  };

  useEffect(() => {
    if (formSubmitted && !sendingData && downloadButtonRef.current) {
      downloadButtonRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [formSubmitted, sendingData]);

  useEffect(() => {
    const loadedDraft = getDraftById(parseInt(draftId));
    if (loadedDraft) {
      setDraft(loadedDraft);

      const content = JSON.parse(loadedDraft.content);
      setProjectName(content.project_name || "");
      setInspectionsType(content.inspection_type_id || "");
      setCustomer(content.customer || "");
      setArea(content.area || "");
      setInspectedDate(content.inspected_date || "");
      setHeadOfInspection(content.head_of_inspection || "");
      setParticipants(content.participants || "");
      setEmail(content.email || []);
      setOtherInfo(content.other_info || "");
    }
  }, [draftId]);

  const handleProjectNameChange = (e) => {
    const newVal = e.target.value;
    setProjectName(newVal);
    if (newVal.length > 0) setProjectError(false);
  };

  return (
    <>
      {onTop ? (
        <Header requiredHeight={170} logout={true} />
      ) : (
        <Header requiredHeight={60} logout={true} />
      )}
      <div
        id={"event"}
        style={{
          marginTop: 10,
          padding: 10,
          overflow: "hidden",
          height: "auto",
        }}
      >
        <div
          className={`container-responsive ${
            isPortrait ? "container-fluid" : "container"
          }`}
          style={{ maxWidth: 750 }}
        >
          <SeperatorHeading heading={"Angaben zur Begehung"} />
          <span>
            <i>Felder, die mit (*) markiert sind, sind Pflichtfelder</i>
          </span>
          <InspectionType
            types={inspectionTypes}
            inspectionTypeError={inspectionTypeError}
            onTypeSelect={handleInspectionTypeChange}
          />

          {inspectionTypeError && (
            <div style={{ color: "#f1807e" }}>
              Bitte wählen Sie die Art der Begehung aus
            </div>
          )}
          <FormField
            label={<span>Projektname*</span>}
            id={"projekt"}
            type={"text"}
            value={projectName}
            onChange={handleProjectNameChange}
            callbackFn={(val) => {
              if (val.length > 0) setProjectError(false);
            }}
            style={{
              border: projectName ? "1px solid #D9D9D9" : "1px solid #f1807e",
            }}
          />
          {projectError && (
            <div style={{ color: "#f1807e" }}>
              Bitte geben Sie den Projektnamen ein.
            </div>
          )}
          <FormField
            label={
              <span>
                Auftraggeber / Kunde{" "}
                <i style={{ fontSize: "12px" }}>(optional)</i>
              </span>
            }
            id={"auftraggeber"}
            type={"text"}
          />
          <FormField
            label={
              <span>
                Bereich <i style={{ fontSize: "12px" }}>(optional)</i>
              </span>
            }
            id={"bereich"}
            type={"text"}
          />
          <FormField
            label={<span>Begehungsdatum*</span>}
            id={"begehungsdatum"}
            type={"date"}
            callbackFn={(val) => {
              if (val.length > 0) setBegehungsdatumError(false);
            }}
            style={{
              border: begehungsdatumError
                ? "1px solid #f1807e"
                : "1px solid #D9D9D9",
            }}
          />
          {begehungsdatumError && (
            <div style={{ color: "#f1807e" }}>
              Begehungsdatum darf nicht leer sein.{" "}
            </div>
          )}

          <FormField
            label={<span>Leitung Inspektion*</span>}
            id={"leitunginspektion"}
            type={"text"}
            callbackFn={(val) => {
              if (val.length > 0) setLeitungInspektionError(false);
            }}
            style={{
              border: leitungInspektionError
                ? "1px solid #f1807e"
                : "1px solid #D9D9D9",
            }}
          />
          {leitungInspektionError && (
            <div style={{ color: "#f1807e" }}>
              Bitte geben Sie den Leitung Inspektion ein.
            </div>
          )}
          <FormField
            label={<span>Teilnehmer Inspektion*</span>}
            id={"teilnehmerinspektion"}
            type={"text"}
            callbackFn={(val) => {
              if (val.length > 0) setTeilnehmerInspektionError(false);
            }}
            style={{
              border: teilnehmerInspektionError
                ? "1px solid #f1807e"
                : "1px solid #D9D9D9",
            }}
          />
          {teilnehmerInspektionError && (
            <div style={{ color: "#f1807e" }}>
              Bitte geben Sie den Teilnehmer Inspektion ein.
            </div>
          )}
          <FormField
            label={
              <span>
                Sonstige Hinweise (Bemerkungen){" "}
                <i style={{ fontSize: "12px" }}>(optional)</i>
              </span>
            }
            id={"sonstige"}
            type={"text"}
          />
          <TextFieldBig />
          <MultiEmailField
            label={"E-Mail des Empfängers*"}
            id={"email"}
            type={"email"}
            delimiter={";"}
            callbackFn={(val) => {
              if (val.length > 0) setEmailError(false);
            }}
            style={{
              border: emailError ? "1px solid #f1807e" : "1px solid #D9D9D9",
            }}
          />
          {emailError && (
            <div style={{ color: "#f1807e", marginTop: "-12px" }}>
              Bitte geben Sie mindestens eine E-Mail des Empfängers ein
            </div>
          )}
          <div className="text-muted" style={{ fontSize: 12 }}>
            (Drücken Sie die Taste Enter oder ;, um eine E-Mail-Adresse
            hinzuzufügen. Um mehrere E-Mail-Adressen einzugeben, trennen Sie
            diese durch ein Leerzeichen oder , oder ;)
          </div>
          {eventList.length > 0 ? (
            <SeperatorHeading heading={"Angaben zum Mangel"} />
          ) : (
            <></>
          )}
          {eventList}

          <div
            className="d-flex justify-content-center"
            style={{ flexDirection: "row" }}
          >
            {eventList.length > 0 &&
            inspectionType !== "Bausstellenbegehung" ? (
              <></>
            ) : (
              <button
                className="btn btn-sifar"
                style={{ marginTop: 10, marginRight: 10, width: "100%" }}
                onClick={() => {
                  onMangelClick();
                }}
              >
                <FontAwesomeIcon icon={faPlus} /> Mängel
              </button>
            )}

            {eventList.length === 0 ? (
              <></>
            ) : (
              <button
                className="btn btn-sifar-filled shadow"
                style={{
                  marginTop: 10,
                  marginLeft: 10,
                  width: "100%",
                }}
                onClick={() => {
                  onSubmit();
                }}
              >
                {sendingData ? (
                  <>
                    <FontAwesomeIcon icon={faEllipsis} /> Bericht erstellen
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faUpload} /> Abschließen
                  </>
                )}
              </button>
            )}
          </div>
          {formSubmitted && !sendingData && submissionType === "sent" ? (
            <div style={{ marginTop: 12, marginBottom: 0 }}>
              <button
                className="btn btn-success shadow download-button"
                style={{ width: "100%" }}
                onClick={() => savePdf()}
                ref={downloadButtonRef}
              >
                <div className="blink-me">
                  <FontAwesomeIcon icon={faDownload} /> Bereit zum Download
                </div>
              </button>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default Form;
